export default class BasketLine
{
    id                        = null;
    quantity                  = null;
    article_code              = null;
    article_data              = {};
    logistics_data            = {};
    return_data               = {};
    dependency_code           = null;
    order_by                  = null;
    delivery_to               = null;
    supplements               = [];
    extra                     = {};
    special_price             = null;
    special_price_is_computed = null;
    ecom                      = null;
    previous_order_reference  = null;
    created_at                = null;
    updated_at                = null;

    //-------------------------------------------------------------------------- CONSTRUCTOR

    constructor(attributes = {})
    {
        if(attributes)
        {
            this.setAttributes(attributes);
        }
    }

    //-------------------------------------------------------------------------- ATTRIBUTES

    setAttributes(attributes)
    {
        for(let key in attributes)
        {
            if(this[key] !== undefined)
            {
                this[key] = attributes[key];
            }
        }
    }

    //-------------------------------------------------------------------------- SETTERS

    setArticleDataAttribute(key, val)
    {
        this.article_data[key] = val;
    }

    setArticleDataAttributeDefaultValue(key, defaultVal)
    {
        if(!this.article_data.defaults)
        {
            this.article_data.defaults = {};
        }

        this.article_data.defaults[key] = defaultVal;
    }

    setLogisticsDataAttribute(key, val)
    {
        this.logistics_data[key] = val;
    }

    setReturnDataAttribute(key, val)
    {
        this.return_data[key] = val;
    }

    setExtraAttribute(key, val)
    {
        this.extra[key] = val;
    }

    //-------------------------------------------------------------------------- GETTERS

    getArticleDataAttribute(key)
    {
        return this.article_data[key];
    }

    getLogisticsDataAttribute(key)
    {
        return this.logistics_data[key];
    }

    getReturnDataAttribute(key)
    {
        return this.return_data[key];
    }

    getExtraAttribute(key)
    {
        return this.extra[key];
    }
}
